import React from "react";

export default function Vector() {
	return (
		<svg
			width="121"
			height="120"
			viewBox="0 0 121 120"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.94953 55.872C13.4795 90.3419 -7.05047 96.3319 14.1395 113.772C31.8695 128.332 63.1395 111.062 83.8395 118.872C98.0295 124.222 118.89 109.872 120.41 89.202C121.81 70.202 106.12 69.782 110.21 48.682C115.11 23.462 114.88 0.00195312 62.6395 0.00195312C10.3995 0.00195312 -6.38047 25.342 2.94953 55.872Z"
				fill="#DBE0E6"
			/>
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M28.4192 20.6924H92.5792C93.4598 20.7296 94.3243 20.9405 95.1231 21.3128C95.922 21.6852 96.6394 22.2117 97.2341 22.8622C97.8288 23.5127 98.2891 24.2742 98.5886 25.1032C98.8881 25.9321 99.0208 26.812 98.9792 27.6924V90.6924C99.0208 91.5728 98.8881 92.4527 98.5886 93.2816C98.2891 94.1105 97.8288 94.8721 97.2341 95.5226C96.6394 96.173 95.922 96.6996 95.1231 97.0719C94.3243 97.4443 93.4598 97.6552 92.5792 97.6924H28.4192C27.5386 97.6552 26.6741 97.4443 25.8752 97.0719C25.0764 96.6996 24.359 96.173 23.7643 95.5226C23.1696 94.8721 22.7093 94.1105 22.4098 93.2816C22.1103 92.4527 21.9776 91.5728 22.0192 90.6924V27.6924C21.9776 26.812 22.1103 25.9321 22.4098 25.1032C22.7093 24.2742 23.1696 23.5127 23.7643 22.8622C24.359 22.2117 25.0764 21.6852 25.8752 21.3128C26.6741 20.9405 27.5386 20.7296 28.4192 20.6924Z"
				fill="white"
				stroke="#B1BDC8"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
				strokeDasharray="1.19 3.81"
			/>
			<path
				d="M87.5492 40.6924H33.4492V48.4324H87.5492V40.6924Z"
				fill="white"
				stroke="#B1BDC8"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M87.5492 57.4219H33.4492V65.1619H87.5492V57.4219Z"
				fill="white"
				stroke="#B1BDC8"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M60.4992 73.582H33.4492V81.322H60.4992V73.582Z"
				fill="#CFD7DF"
				stroke="#CFD7DF"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	);
}
